import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginComponent } from './components/login/login.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { PasswordUpdateComponent } from './components/password-update/password-update.component';
import { SecurityComponent } from './security.component';
import { LogoutComponent } from './components/logout/logout.component';
import { TokenErrorComponent } from './components/token-error/token-error.component';
import { MfaSetupComponent } from './components/mfa-setup/mfa-setup.component';
import { MfaSetupCompleteComponent } from './components/mfa-setup-complete/mfa-setup-complete.component';

const routes: Routes = [
  {
    path: '',
    component: SecurityComponent,
    canActivate: [],
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      { path: 'password-reset', component: PasswordResetComponent },
      { path: 'password-update', component: PasswordUpdateComponent },
      { path: 'logout', component: LogoutComponent },
      { path: 'token-error', component: TokenErrorComponent },
      { path: 'mfa-setup', component: MfaSetupComponent },
      { path: 'mfa-setup-complete', component: MfaSetupCompleteComponent },
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class SecurityRoutingModule {

}
